/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css as cssUnbounded } from '@compiled/react';

import { jsx, css } from '@atlaskit/css';
import Link from '@atlaskit/link';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import type { Disclaimer } from '../types';

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const footerInformationStylesUnbounded = cssUnbounded({
	minWidth: 0,
	minHeight: token('space.300'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'& > p, & > div': {
		font: token('font.body.small'),
		color: token('color.text.subtle'),
		marginTop: 0,
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'& > span': {
		marginTop: token('space.050'),
		marginRight: token('space.050'),
		marginBottom: token('space.050'),
	},
});

const footerInformationStyles = css({
	display: 'flex',
	flexWrap: 'wrap',
	alignItems: 'center',
});

export interface CustomDisclaimerProps {
	/** Custom disclaimer to be displayed in the footer. */
	disclaimer: Disclaimer;
}

/**
 * Custom disclaimer to be displayed in the footer.
 *
 */
export function CustomDisclaimer({ disclaimer }: CustomDisclaimerProps): JSX.Element {
	return (
		<div css={[footerInformationStyles, footerInformationStylesUnbounded]}>
			<Box testId="custom-disclaimer">
				<Tooltip content={disclaimer.tooltip} position="top">
					{disclaimer.url ? (
						<Link href={disclaimer.url} target="_blank" rel="noopener noreferrer">
							{disclaimer.text}
						</Link>
					) : (
						<span>{disclaimer.text}</span>
					)}
				</Tooltip>
			</Box>
		</div>
	);
}
